import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import HistoryTagSelectBottomSheet from '@di-shared/features/history/filter/HistoryTagSelectBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

export default function HistoryTagSelectPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <HistoryTagSelectBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}
